module.exports = "/packs/banner_sp_study_plan_notion-ca481c09ebb176502c1bebe8f03a78b4.png";